<p-dialog
	header="Supporting Documents"
	[visible]="visible"
	[modal]="true"
	[closable]="!isUploading"
	[closeOnEscape]="!isUploading"
	[dismissableMask]="!isUploading"
	[draggable]="false"
	[resizable]="false"
	[style]="{ width: '680px', maxWidth: '95vw' }"
	[breakpoints]="{
      '960px': '80vw',
      '640px': '95vw'
   }"
	(visibleChange)="onDialogVisibleChange($event)"
>
	<div class="supporting-files-modal">
		<section class="supporting-files-context">
			<strong>Row supporting documents</strong>
			<span>
            Files uploaded here are attached to this report row.
         </span>
		</section>

		<div
			*ngIf="loadError"
			class="supporting-files-message supporting-files-message-error"
			role="alert"
		>
			<i class="pi pi-exclamation-circle"></i>
			<span>{{ loadError }}</span>
		</div>

		<div
			*ngIf="uploadError"
			class="supporting-files-message supporting-files-message-error"
			role="alert"
		>
			<i class="pi pi-exclamation-circle"></i>
			<span>{{ uploadError }}</span>
		</div>

		<div
			*ngIf="uploadSuccess"
			class="supporting-files-message supporting-files-message-success"
			role="status"
		>
			<i class="pi pi-check-circle"></i>
			<span>{{ uploadSuccess }}</span>
		</div>

		<section class="supporting-files-list">
			<div class="supporting-files-heading">
				<h3>Documents</h3>

				<span *ngIf="!isLoading">
               {{ supportingFiles.length }}
					{{ supportingFiles.length === 1 ? 'file' : 'files' }}
            </span>
			</div>

			<div *ngIf="isLoading" class="supporting-files-loading">
				<i class="pi pi-spin pi-spinner"></i>
				<span>Loading supporting documents...</span>
			</div>

			<div
				*ngIf="!isLoading && !supportingFiles.length && !loadError"
				class="supporting-files-empty"
			>
				No supporting documents have been uploaded for this row.
			</div>

			<div
				*ngIf="!isLoading && supportingFiles.length"
				class="supporting-files-items"
			>
				<div
					*ngFor="
                  let file of supportingFiles;
                  trackBy: trackFileById
               "
					class="supporting-file-item"
				>
					<div class="supporting-file-details">
						<i class="pi pi-file"></i>

						<div>
							<strong>{{ file.fileName || 'Supporting document' }}</strong>

							<span *ngIf="file.createdBy">
                        Uploaded by {{ file.createdBy }}
                     </span>

							<span *ngIf="file.createdDate">
                        {{
									file.createdDate
										| DatePropertyTimezone: true : true
								}}
                     </span>
						</div>
					</div>

					<button
						pButton
						type="button"
						icon="pi pi-download"
						class="p-button-text p-button-sm"
						[loading]="isDownloading(file)"
						[disabled]="!file.id || isDownloading(file)"
						aria-label="Download supporting document"
						title="Download"
						data-cy="pms-row-supporting-file-download"
						(click)="downloadFile(file)"
					></button>
				</div>
			</div>
		</section>

		<section class="supporting-files-upload">
			<div>
				<h3>Upload document</h3>
				<p>
					Add evidence or approval documentation for this row.
				</p>
			</div>

			<p-fileUpload
				#fileUpload
				data-cy="pms-row-supporting-file-upload"
				mode="basic"
				name="supportingFile"
				chooseLabel="Choose file"
				[customUpload]="true"
				[multiple]="false"
				[disabled]="!canUpload"
				accept=".pdf,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx,.csv"
				(uploadHandler)="onUpload($event)"
			></p-fileUpload>

			<span *ngIf="isUploading" class="supporting-files-uploading">
            <i class="pi pi-spin pi-spinner"></i>
            Uploading document...
         </span>
		</section>

		<div class="supporting-files-actions">
			<button
				pButton
				type="button"
				label="Close"
				class="p-button-text"
				[disabled]="isUploading"
				(click)="closeModal()"
			></button>
		</div>
	</div>
</p-dialog>
